fieldNodeSet